export default __webpack_public_path__ + "static/media/Ashanti_img_107.56366ac8.jpg";